import { render, staticRenderFns } from "./merchantApplyCompetition.vue?vue&type=template&id=1628ae26&scoped=true"
import script from "./merchantApplyCompetition.vue?vue&type=script&lang=ts"
export * from "./merchantApplyCompetition.vue?vue&type=script&lang=ts"
import style0 from "./merchantApplyCompetition.vue?vue&type=style&index=0&id=1628ae26&prod&lang=stylus&scoped=true"
import style1 from "./merchantApplyCompetition.vue?vue&type=style&index=1&id=1628ae26&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1628ae26",
  null
  
)

export default component.exports